import D from "@/admin/dashboard/Dashboard.module.css";

import { BigDonut } from "@/admin/dashboard/DonutChart.tsx";
import { LegendTable } from "@/admin/dashboard/LegendTable.tsx";
import { LightBlock } from "@/admin/dashboard/LightBlock.tsx";
import { adminIpPoolQueryAtom } from "@/admin/floating_ips/floatingIpsQuery.ts";
import { Separator } from "@/components/Separator.tsx";
import { locationSlugsAtom } from "@/modules/api/locations.store.ts";
import { SuspenseErrorBoundary } from "@/modules/error/ErrorFallback.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { useAtomValue } from "jotai";

function LocationFloating({ location }: { location: string }) {
    const item = useSuspenseQueryAtom(adminIpPoolQueryAtom(location));

    const { percent_used, used_ips, total_ips } = item;

    const items = [
        { value: used_ips, color: "var(--color-chart-2)" },
        { value: total_ips - used_ips, color: "var(--color-chart-free)" },
    ];

    const tooltipContent = (
        <LegendTable
            items={[
                { label: "Used:", value: used_ips, color: "color-chart-2" },
                { label: "Available:", value: total_ips - used_ips, color: "color-chart-free" },
            ]}
        />
    );

    return (
        <BigDonut
            items={items}
            tooltipContent={tooltipContent}
            total={total_ips}
            location={location}
            percentUsed={percent_used}
        />
    );
}

function FloatingSectionContent() {
    const locations = useAtomValue(locationSlugsAtom);

    return (
        <>
            <h2 className="font-size-heading">Floating IPs</h2>
            <p className="pb-3">Floating IP pool usage</p>
            <Separator />
            <div className={D.Grid}>
                {locations.map((location) => (
                    // Separate error boundary for each location so one failure doesn't break the whole section
                    <SuspenseErrorBoundary key={location} loadingHeight="260px" tags={["admin", "FloatingSection"]}>
                        <LocationFloating location={location} />
                    </SuspenseErrorBoundary>
                ))}
            </div>
        </>
    );
}

export function FloatingSection() {
    return (
        <LightBlock className={D.Wide}>
            <FloatingSectionContent />
        </LightBlock>
    );
}
